
<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      } else {
        if (this.$route.query.hShow && this.$route.query.from) {
          return {
            is: 'router-link',
            to: url + '?hShow=true&from=byh'
          }
        } else if (this.$route.query.hShow && !this.$route.query.from) {
          return {
            is: 'router-link',
            to: url + '?hShow=true'
          }
        }
        return {
          is: 'router-link',
          to: url
        }
      }
    }
  }
}
</script>
